import React from 'react';

const CopyIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.83594 8.056C5.83594 7.46655 6.07009 6.90125 6.48689 6.48445C6.90369 6.06765 7.46899 5.8335 8.05844 5.8335H15.2801C15.572 5.8335 15.861 5.89098 16.1306 6.00267C16.4003 6.11437 16.6453 6.27807 16.8516 6.48445C17.058 6.69083 17.2217 6.93584 17.3334 7.20548C17.4451 7.47513 17.5026 7.76413 17.5026 8.056V15.2777C17.5026 15.5695 17.4451 15.8585 17.3334 16.1282C17.2217 16.3978 17.058 16.6428 16.8516 16.8492C16.6453 17.0556 16.4003 17.2193 16.1306 17.331C15.861 17.4427 15.572 17.5002 15.2801 17.5002H8.05844C7.76657 17.5002 7.47757 17.4427 7.20792 17.331C6.93828 17.2193 6.69327 17.0556 6.48689 16.8492C6.28051 16.6428 6.11681 16.3978 6.00512 16.1282C5.89342 15.8585 5.83594 15.5695 5.83594 15.2777V8.056Z'
        stroke='currentColor'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.34333 13.9475C3.0875 13.8021 2.87471 13.5917 2.72658 13.3374C2.57846 13.0832 2.50028 12.7942 2.5 12.5V4.16667C2.5 3.25 3.25 2.5 4.16667 2.5H12.5C13.125 2.5 13.465 2.82083 13.75 3.33333'
        stroke='currentColor'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CopyIcon;
